<template>
    <listeRevue v-if="!selected" @selected-revue="selectedRevue"/>
    <RevueRecherche v-if="selected" @unselected-revue="unselectedRevue" :currentAbonnement="currentAbonnement"/>
</template>

<script>
import listeRevue from '@/components/recherche/listeRevue.vue'
import RevueRecherche from '@/components/recherche/RevueRecherche.vue'

export default {
    name: "BlocRevue",
    components: {
        listeRevue,
        RevueRecherche,
    },
    data() {
        return {
            selected: false,
            currentAbonnement: null,
        }
    },
    methods: {
        selectedRevue(abonnement) {
            this.selected = true
            this.currentAbonnement = abonnement
        },
        unselectedRevue() {
            this.selected = false
            this.currentAbonnement = null
        }
    },
}
</script>

<style lang="scss" scoped></style>